import React, { PropsWithChildren } from "react";
import { Breadcrumbs } from "./breadcrumbs";
import { CookieBanner } from "./cookie-banner";
import { Footer } from "./footer";
import { Navigation } from "./navigation";
import { SEO } from "./seo";
import { Script, graphql, useStaticQuery } from "gatsby";

export const Layout: React.FC<
  PropsWithChildren & {
    contentId?: string;
    noBreadcrumbs?: boolean;
    showSearch?: boolean;
    seo?: {
      type?: string;
      title?: string;
      description?: string;
      image?: string;
    };
  }
> = ({ children, contentId, noBreadcrumbs = false, showSearch, seo }) => {
  const data: Queries.LayoutQuery = useStaticQuery(graphql`
    query Layout {
      strapiGlobalContent {
        Header_code
        Footer_code
      }
    }
  `);
  return (
    <div
      className={`overflow-x-hidden bg-light-gray text-purple ${
        !noBreadcrumbs ? "pt-28 lg:pt-52" : "pt-2 lg:pt-24"
      }`}
    >
      <Script
        dangerouslySetInnerHTML={{
          __html: data.strapiGlobalContent?.Header_code || "",
        }}
      ></Script>
      <SEO {...seo} />
      <Navigation showSearch={showSearch} />
      <Breadcrumbs id={contentId} />
      <main className="content-area mb-24 mt-20">{children}</main>
      <Footer />
      <CookieBanner />
      <div
        dangerouslySetInnerHTML={{
          __html: data.strapiGlobalContent?.Footer_code || "",
        }}
      ></div>
    </div>
  );
};
